import FORM_BUILDER from 'ui-blocks/form-builder/constants';
import {
   sponsoredAdsPublisherTrafficRuleCreate,
   sponsoredAdsPublisherTrafficRuleUpdate, sponsoredAdsPublisherTrafficRuleGet,
} from '../../../services/servicesSponsoredAds';

const formBuilderConfig = {
   defaultInitialValues: {
      type: {
         label: 'Blacklist',
         value: 'publisher_blacklist',
      },
      device: {
         label: 'All Devices',
         value: '',
      },
      advertisers: [],
      campaigns: [],
      publishers: [],
      sources: [],
      contracts: [],
   },
   settings: {
      type: FORM_BUILDER.TYPE.EDIT_ADD,
      internal: {
         routing: {
            basePath: '/sponsored-ads/traffic-rules/publisher-rules',
         },
      },
      external: {
         api: {
            get: sponsoredAdsPublisherTrafficRuleGet,
            save: {
               create: sponsoredAdsPublisherTrafficRuleCreate,
               edit: sponsoredAdsPublisherTrafficRuleUpdate,
            },
            // getInitialValues:       -- value is a promise
            // save :                  -- has two value variations to take into consideration for the (1) Case: theres one API for
            //                            create & edit and for the (2) Case: where theres two separate APIs for 'create' and 'edit'
            //          E.g., Save Variation Value #1 -- value is a promise
            //          E.g., Save Variation Value #2 -- value is an object with the shape
            //                {
            //                   edit,       // -- value is a promise
            //                   create,     // -- value is a promise
            //                }
            responseMiddleware: {
               get: (resData) => {
                  const initialValues = { ...resData };
                  initialValues.sources = resData.sources?.map((source, id) => (
                     { name: source, id }
                  ));
                  initialValues.device = resData.device || '';
                  return initialValues;
               },
            },
         },
      },
   },
};

export default formBuilderConfig;
